import { Box, Typography, Link } from '@mui/material'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    padding: '50px',
    gap: '20px'
  },
  title: {
    fontWeight: 'bold'
  }
}

export const PartnerInsights = () => {
  return (
    <Box sx={styles.container} data-testid="partner-insights">
      <Typography variant="h5" sx={styles.title}>
        Easily Partner with Leading National Brands
      </Typography>

      <Typography variant="body1">
        StackMedia helps publishers generate additional revenue streams via
        native content solutions. We’ll connect you with top national brands and
        deliver engaging sponsored content that enhances the overall reader
        experience.
      </Typography>

      <Typography variant="body1">
        Contact Us For More Information -{' '}
        <Link
          href="mailto:advertising@stackcommerce.com"
          target="_blank"
          rel="noreferrer"
        >
          advertising@stackcommerce.com
        </Link>
      </Typography>
    </Box>
  )
}
